import { dummyData } from '../dummy';
import { MainImages } from '@lemon/assets';

const image = MainImages.tint;
const GRID = 6;
const CENTER = Math.floor(GRID / 2);

// 데이터 어떻게 들어올지 몰라서 임의로 만들어 놓음
export const ToneMap = () => {
    const { light, bright, murky, dark } = dummyData.toneMap;

    const x = murky - bright;
    const y = light - dark;

    const toGrid = (v: number) => CENTER + v;

    const targetRow = toGrid(-y);
    const targetCol = toGrid(x);

    const isInGrid = targetRow >= 0 && targetRow < GRID && targetCol >= 0 && targetCol < GRID;

    return (
        <div className="w-full h-full flex flex-col items-start justify-center py-10">
            <div>컬러 맵</div>
            <div className="relative mt-6">
                {/* Axis labels */}
                <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-sm font-semibold text-foreground">
                    밝은
                </div>
                <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-sm font-semibold text-foreground">
                    어두운
                </div>
                <div className="absolute -left-10 top-1/2 -translate-y-1/2 text-sm font-semibold text-foreground">
                    맑은
                </div>
                <div className="absolute -right-10 top-1/2 -translate-y-1/2 text-sm font-semibold text-foreground">
                    탁한
                </div>

                <div className="grid grid-cols-6 gap-0 border-2 border-primary-black rounded-lg overflow-hidden ">
                    {[...Array(GRID * GRID)].map((_, index) => {
                        const row = Math.floor(index / GRID);
                        const col = index % GRID;
                        const isTarget = isInGrid && row === targetRow && col === targetCol;

                        return (
                            <div
                                key={index}
                                className={`w-20 h-20 border border-dashed border-primary-black relative flex items-center justify-center bg-muted/20 `}
                            >
                                {isTarget && <img src={image} alt="tone cell" className="w-full h-full object-cover" />}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
